import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiAuth from "./useApiAuth";
import UserRegister from "../interfaces/userRegister";

const useRegister = () => {
    const { register } = useApiAuth();

    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (user: UserRegister) => register(user),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["users"]});
        }
    })
}

export default useRegister;